<template>
  <div class="pageContent" style="position:absolute;">
    <div
      style=" z-index:1111;   border: 1px solid #ccc; max-width:480px;  width: 100%; overflow:hidden; color: #333; position:fixed ; background-color:white ;  "
      v-if="false"
    >
      <div
        style="  float:left;    ;line-height:100%  ;  padding:0.5rem 0.2rem 0.3rem 0.2rem; "
        v-on:click="showToggle()"
      >
        <img
          src="../../../static/home/index/icon_close.png"
          style="   width:0.22rem ;margin:0 auto; "
        >
      </div>
      <img
        src="../../../static/home/index/logoapp.png"
        style="float:left;width:1.24rem"
        v-on:click="GoDown()"
      >
      <div
        style="  float: left;  margin-top:0.2rem;  line-height: 1.6;  font-size: 0.28rem;  "
        v-on:click="GoDown()"
      >
        <div>下载APP得￥100代金券礼包</div>
        <div style=" font-size: 0.22rem; color:#999">绑定手机和邮箱再得￥100</div>
      </div>
      <div
        style="float:right;background-color:#27ba69 ; width:1.5rem ;text-align: center ; height:1.24rem ;
       color:white ; padding-top:0.4rem ; font-size:0.3rem "
        v-on:click="GoDown()"
      >立即下载</div>
    </div>
    <!-- 把上面那个撑开 -->
    <div style="  height:1.24rem;   " v-if="false"></div>

    <div class="slider" style="max-height: 4.3rem">
      <swiper :options="swiperOption11">
        <swiper-slide v-for="(item,index) in banners" :key="index">
            <img :src="item.url" @click="bannerGoto(item.detailUrl)"> 
          <!-- :alt="item.url" -->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="search">
      <mu-paper class="demo-paper" :zDepth="1">
        <div class="search-panel">
          <mu-tabs :value="activeTab" @change="handleTabChange" class="tabDiv">
            <mu-tab value="tabFirst" title="全日房"/>
            <mu-tab value="tabSecond" title="休闲房"/>
          </mu-tabs>
          <div v-show="activeTab === 'tabFirst'" id="Index_FirstPage" style="position: relative;">
            <div style="width:100%;height:100%;position: absolute;z-index:999999" @click.stop="toWxUrll"></div>
            <mu-text-field
              hintText="城市"
              id="FirstCity"
              type="text"
              icon="location_city"
              iconClass="colorCCC"
              v-model="this.g_currentCityName"
              @focus="selectCity"
              underlineShow
            />
            <div style=" float:right ; padding-right:0.4rem ; ">
              <router-link to="/search/nearbyHotels">
                <img
                  src="../../../static/home/index/near.png"
                  style=" width:0.35rem ; margin-top: 0.3rem "
                >
                <div style=" float:right  ;  padding-top: 0.3rem  ">附近酒店</div>
              </router-link>
            </div>

            <mu-divider class="dividerClass"/>

            <div style=" width:100% ; overflow:hidden">
              <div class="BoxLeft" style="position:relative">
                <mu-date-picker
                  v-model="g_searchParam.startDate"
                  :format="dateFormt"
                  :maxDate="checkinMaxDate"
                  :minDate="checkinMinDate"
                  hintText="入住日期"
                  icon="date_range"
                  iconClass="colorCCC"
                  @change="checkinDateChange"
                />

                <div
                  v-if="BuyZero == true "
                  style="position:absolute;margin:-0.7rem 0 0 1rem ; z-index:999999 ; width:2.5rem ; height:0.7rem"
                >
                  <!-- 用来阻挡选择日期，只有在使用凌晨房的时候阻挡 -->
                </div>
                <div class="DateShow">
                  <div style="font-size:0.28rem ;  ">
                    {{checkInDateFormat}}
                    <span
                      style="font-size:0.2rem ; color:#FF8F3B   "
                      v-if="BuyZero == true"
                    >凌晨入住</span>
                    <span style="font-size:0.2rem ; color:#FF8F3B   " v-else>入住</span>
                  </div>
                </div>
              </div>

              <div style="width:0.9rem ;height:0.1rem ;  float:left" v-if="!ShowZero"></div>

              <div class="BoxRight" style="position:relative">
                <mu-date-picker
                  v-model="g_searchParam.endDate"
                  :format="dateFormt"
                  hintText="离店日期"
                  :maxDate="checkoutMaxDate"
                  :minDate="checkoutMinDate"
                  @change="checkoutDateChange"
                />
                <div class="DateShow" style="left:0 ; ">
                  <div style="font-size:0.28rem ;  ">
                    {{checkOutDateFormat}}
                    <span
                      style="font-size:0.2rem ;"
                      v-if="BuyZero == true"
                    >中午离店</span>
                    <span style="font-size:0.2rem ; " v-else>离店</span>
                  </div>
                </div>
              </div>

              <div style="position: relative;" v-if="ShowZero">
                <div
                  style="position: absolute; line-height:55px; right:0; z-index:999999 ;; width:2rem ; font-size:0.25rem ;   "
                >
                  <span
                    style="  z-index:999999 "
                    class="TEXT_primaryColor"
                    v-if="BuyZero == false "
                  >凌晨房</span>
                  <span
                    style=" color:transparent; z-index:999999 "
                    class="TEXT_primaryColor"
                    v-else
                  >占格子</span>
                  <mu-switch style="margin:0 0 0  0.1rem ; bottom:-0.02rem " @change="changeZero"/>
                </div>
              </div>
            </div>

            <mu-divider class="dividerClass"/>
            <mu-text-field
              inputClass="selectKey"
              :fullWidth="true"
              type="text"
              icon="search"
              iconClass="colorCCC"
              v-model="this.g_searchKeyWord"
              @focus="selectKey"
            />
            <mu-divider class="dividerClass"/>
            <mu-flexbox-item class="flex-search">
              <mu-raised-button
                label="开始预订"
                primary
                @click="searchHotel"
                v-bind:style="{ width:'90%',height:'50px'}"
                style="font-size:0.32rem"
              />
            </mu-flexbox-item>
            <mu-divider/>
          </div>

          <!--第二个标签页-->
          <div v-show="activeTab === 'tabSecond'" id="Index_SecondPage">
            <mu-text-field
              hintText="城市"
              id="SecondCity"
              type="text"
              icon="location_city"
              iconClass="colorCCC"
              v-model="this.g_currentCityName"
              @focus="selectCity"
              underlineShow
            />
            <mu-divider class="dividerClass"/>

            <div style="position:relative;">
              <mu-date-picker
                id="SecondCity"
                v-model="g_searchParam.arriveDate"
                format="YYYY-MM-DD"
                hintText="入住日期"
                icon="date_range"
                iconClass="colorCCC"
                :maxDate="checkinMaxDate"
                :minDate="checkinMinDate"
                @change="setRelaxDate"
                style=" float:left ; width:3rem "
              />
              <span class="formatDate" style="font-size:0.28rem ;  ">{{arriveDateFormat}}</span>
            </div>

            <mu-dropDown-menu
              :value="relaxHour"
              @change="setRelaxHour"
              icon="search"
              iconClass="colorCCC"
              style="float:right ; width:2.5rem ; margin-top:-0.07rem ;  font-size:0.3rem  "
              id="Timehomeindex"
            >
              <mu-menu-item value="11" title="11:00"/>
              <mu-menu-item value="12" title="12:00"/>
              <mu-menu-item value="13" title="13:00"/>
              <mu-menu-item value="14" title="14:00"/>
              <mu-menu-item value="15" title="15:00"/>
              <mu-menu-item value="16" title="16:00"/>
            </mu-dropDown-menu>
            <div style="clear:both"></div>
            <mu-divider class="dividerClass"/>

            <mu-text-field
              inputClass="selectKey"
              :fullWidth="true"
              type="text"
              icon="search"
              iconClass="colorCCC"
              v-model="this.g_searchKeyWord"
              @focus="selectKey"
            />
            <!--<mu-text-field  type="text" icon="search" iconClass="colorCCC" v-model="this.g_searchKeyWord" @focus="selectKey" :fullWidth='true' />-->
            <!--hintText="行政区/商圈/门店"-->
            <mu-divider class="dividerClass"/>
            <mu-flexbox-item class="flex-search">
              <!--<mu-raised-button label="开始预订" primary @click="goListToRelax" v-bind:style="{ width:'90%',height:'50px'}" />-->
              <mu-raised-button
                label="开始预订"
                primary
                @click="goListToRelax()"
                v-bind:style="{ width:'90%',height:'50px'}"
                style="font-size:0.32rem"
              />
            </mu-flexbox-item>
          </div>
        </div>
      </mu-paper>

      <!-- <div class="nearby">
        <router-link to="/search/nearbyHotels">
          <img src='../../../static/home/index/near.png' />附近酒店
        </router-link>

        
          <a href="#/bookBoardroom/index">
            <img src='../../../static/home/index/meeting.png'/> 会议室预定
          </a>
      </div>-->
      <div style="height:0.2rem"></div>

      <div class="subMenu" style="color:#666666">
        <div class="EntranceBox">
          <a href="https://www.168.com/mobile/index/index.html ">
            <div>
              <img src="../../../static/home/index/168.png">
            </div>
            <div>168商城</div>
          </a>
        </div>
        <div class="EntranceBox">
          <span v-on:click="GoRedBag()">
            <div>
              <img src="../../../static/home/index/RedBag.png">
            </div>
            <div>限时红包</div>
          </span>
        </div>
        <div class="EntranceBox">
          <span v-on:click="GoActivityList()">
            <div>
              <img src="../../../static/home/index/activity.png">
            </div>
            <div>活动</div>
          </span>
        </div>
        <div class="EntranceBox">
          <span v-on:click="GoNewsCenter()">
            <div>
              <img src="../../../static/home/index/news.png">
            </div>
            <div>新闻</div>
          </span>
        </div>
        <div class="EntranceBox">
          <a href="https://i.998.com/applink.htm">
            <div>
              <img src="../../../static/home/index/app.png">
            </div>
            <div>下载APP</div>
          </a>
        </div>
      </div>
    </div>

    <div class="brands" style="margin-bottom:0px;">
      <h3>品牌</h3>
      <div class="slider">
        <swiper :options="swiperOption22">
          <swiper-slide v-for="(item,index) in brands" :key="index">
            <img :src="item.url" @click="BrandGoto(item.id)">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>

    <div
      class="enters"
      style="margin-top:40px;border-bottom:none;text-align:center;font-size:0.2rem;color:#27ba69"
    >
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702001346"
      >沪公网安备 31010702001346号</a>
      <br>格林豪泰酒店（中国）有限公司版权所有
      <br><a href="http://beian.miit.gov.cn">沪ICP备14035076号</a>
    </div>
  </div>
</template>


 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import api from "../../api";
import cookie from "../../utils/cookie.js";
import date from "../../utils/dateextend.js";
import { mapMutations, mapGetters } from "vuex";
// import VueCupUi from 'vue-cup-ui';
// import 'vue-cup-ui/lib/vue-cup-ui.css';

var imgPath = "../../../static/home/index/";

export default {
  data() {
    return {
      swiperOption11: {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000,
        mousewheelControl: true,
        // loop: true,
        initialSlide: 0,
        slidesPerView: 1
      },
      swiperOption22: {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000,
        initialSlide: 0
      },
      banners: [],
      activeTab: "tabFirst",
      relaxHour: "11",
      dateFormt: "YYYY-MM-DD",
      brands: [
        {
          url: "../../../static/home/index/brand_1.jpg",
          id: "40"
        },
        // 格美 20// 格雅 21// 格菲 22
        {
          url: "../../../static/home/index/brand_6.jpg",
          id: "20"
        },
        {
          url: "../../../static/home/index/brand_7.jpg",
          id: "21"
        },
        {
          url: "../../../static/home/index/brand_8.jpg",
          id: "22"
        },

        {
          url: "../../../static/home/index/brand_2.jpg",
          id: "00"
        },
        {
          url: "../../../static/home/index/brand_3.jpg",
          id: "30"
        },
        {
          url: "../../../static/home/index/brand_4.jpg",
          id: "50"
        },
        {
          //5
          url: "../../../static/home/index/brand_5.jpg",
          id: "70"
        },
        {
          url: "../../../static/home/index/brand_9.jpg",
          id: "81"
        }

        // {
        //   url:'../../../static/home/index/brand_9.jpg',
        //   id:'90'
        // },
      ],
      // 凌晨房
      BuyZero: false,
      ShowZero: false,

      isActive: true
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {
    //console.log("-----created----")
      upsdk.pluginReady (function(){
         //console.log("-----云闪付测试111")
          upsdk.setTitleStyle({
             backBtnVisible: '0', // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示 
           });
        });
    // this.get();
    //第一次加载或刷新时重置时间
    this.initDate();

    // 缓存里面初始化成FALSE
    var searchParam = this.g_searchParam;
    searchParam.isZeroRoom = false;
    this.setG_searchParam(searchParam);
    this.BuyZero = false;
  },
  activated() {
          //console.log("-----activated----")
      upsdk.pluginReady (function(){
         //console.log("-----云闪付测试112")
          upsdk.setTitleStyle({
             backBtnVisible: '0', // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示 
           });
        });
    if (this.banners.length == 0) {
      this.get();
    }

    this.setSearchType();
    this.checkDateOut();

    // 销毁酒店列表页，筛选限制

    // var time = new Date().Format("yyyy-MM-dd HH:mm:ss");

    var time = new Date().Format("HH");

    if (time >= 0 && time < 6) {
      this.ShowZero = true;
    }
 
    if(this.$route.query.type == 'ysf'){
       sessionStorage.setItem(window.location.hostname + "_hometype","ysf");
    }
    // upsdk.pluginReady (function(){
    //       upsdk.setTitleStyle({
    //          backBtnVisible: '0', // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示 
    //        });
    //     });

     //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {     
      if (res.Result) {
        //console.log("111");
        this.loginState = true
      }
      else {
        //console.log("222");
        this.CheckLogin(); 
      }
    }) 
  },
  
  mounted() {
      // console.log("-----mounted----")
      // upsdk.pluginReady (function(){
      //     console.log("-----云闪付测试114")
      //         upsdk.setTitleStyle({
      //          // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色。
      //           navBackgroundColor: "0x8FFFFFFF",
      //           appletStyle: "black", //可选，black-黑色主题，white-白色主题。
      //           backBtnVisible: "0", // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示
      //           appletTitleBarVisible: "1", // 可选，标题栏是否显示。’0’不显示，’1’显示，默认显示
      //         });
      //       });
      if(cookie.get("g_UserInfo")){
        this.setG_UserInfo(UserInfo);
      }
    },

  methods: {
    // 何庆兰的顶部遮罩层
    showToggle: function() {
      this.isActive = !this.isActive;
    },

    // 活动页面跳转
    bannerGoto(IDCode) {
      // window.location.href="http://m.998.com/ActivityInfo/ActivityYekCMSDetail.html?dataId="+id;
      window.location.href = IDCode;
      // var params = new this.URLSearchParam();
      // params.append("activityId", IDCode);

      // this.$http.post(api.GetActivityUrl(), params.toParam()).then(res => {
      //   if (res.Result) {
      //     window.location.href = res.Data;
      //     // console.log(   res.Data  )
      //   }
      // });
    },

    GoDown() {
      window.location.href = "https://i.998.com/applink.htm";
    },

    // 凌晨房按钮
    changeZero(val) {
      this.BuyZero = !this.BuyZero;
      var searchParam = this.g_searchParam;

      if (this.BuyZero == true) {
        searchParam.startDate = new Date().Format("yyyy-MM-dd");
        searchParam.endDate = new Date().Format("yyyy-MM-dd");
        // alert( this.BuyZero+"|"+searchParam.endDate )
      } else {
        searchParam.startDate = this.g_searchParam.startDate;
        searchParam.endDate = new Date(this.g_searchParam.startDate)
          .DateAdd("d", 1)
          .Format("yyyy-MM-dd");
        // alert( this.BuyZero+"|"+searchParam.endDate )
      }

      searchParam.isZeroRoom = this.BuyZero;
      this.setG_searchParam(searchParam);
    },

    GoRedBag() {
      this.$router.push({ path: "/activity/AppRedBag?sourcecode=AC0027" });
    },

    // 前往新闻中心
    GoNewsCenter() {
      this.$router.push({ path: "/home/newsCenter" });
    },

    GoActivityList() {
      this.$router.push({ path: "/home/activityList" });
    },

    BrandGoto(BrandID) {
    //   this.$router.push({ path: "/home/brandIntroduce?BrandID=" + BrandID });
      window.location.href = "https://h5app.greentree.cn/brandExhibition/index.html#/oldBrand/" + BrandID;
    },

    get() {
      this.$http.post(api.getBanners()).then(res => {
        if (res.Result) 
        {
          this.banners = res.Data;
          // debugger;
          // console.log(this.banners)
        }
      });
    },
    clearSearchParam() {
      var searchParam = this.g_searchParam;
      //searchParam.cityId='';
      searchParam.hotelCode = "";
      //searchParam.startDate='';
      //searchParam.endDate='';
      searchParam.promotionType = "";
      searchParam.HotelTypeId = "";
      searchParam.areaId = "";
      searchParam.pointX = "";
      searchParam.pointY = "";
      searchParam.PointType = "";
      searchParam.PointText = "";
      searchParam.Sort = "";
      searchParam.SortType = "asc";
      searchParam.PageIndex = "1";
      searchParam.PageSize = "10";
      return searchParam;
    },
    //设置是否是全日房
    setSearchType() {
      var searchParam = this.g_searchParam;
      if (this.activeTab == "tabFirst") {
        searchParam.isFull = true;
      } else {
        searchParam.isFull = false;
      }
      this.setG_searchParam(searchParam);
    },
    handleTabChange(val) {
      this.activeTab = val;
      var searchParam = this.clearSearchParam();
      //searchParam.areaId = "";
      this.setG_searchParam(searchParam);

      this.setG_searchKeyWord("");
      this.setSearchType();
    },
    selectCity() {
      this.$router.push({ path: "/search/selectCity" });
    },
    selectKey() {
      this.$router.push({ path: "/search/key" });

    },
    searchHotel() {
      this.$router.push({ path: "/search/list" });
    },
    toWxUrll(){
        this.$http.post("https://basic-extended.greentree.cn/basic/getAppUrlLink", {
            "appCode":"GTCRSV3",
            "appType":"Tencent",
            "path":"pages/home/index"
        }).then((res) => {     
        console.log(res)
            if(res.data.urlLink != ""){
                // wxUrl.value = res.data.urlLink;
                window.location.href = res.data.urlLink;
            }
        }).catch(err => {
            console.log(err)
        }) 
    },
    //前往休闲房   这里怎么一个参数也没有！这不对！
    goListToRelax() {
      this.$router.push({ path: "/search/ListToRelax" });
    },

    //初始化日期
    initDate() {
      var nowDate = new Date();
      var inDate = nowDate.Format("yyyy-MM-dd"); //入住日期为当天
      var outDate = nowDate.DateAdd("d", 1).Format("yyyy-MM-dd"); //离店日期为明天
      this.reWriteQueryDate(inDate, outDate);

      //  休闲房入住日期初始化
      this.setRelaxDate(inDate);
      //  休闲房入住时间初始化
      this.setRelaxHour("11");
    },
    //检查时间是否超时（入住时间小于今天）
    checkDateOut() {
      // var day = date.daysBetween(new Date().Format("yyyy-MM-dd"),this.g_searchParam.startDate)
      // if (day < 0) {
      //   this.initDate()
      // }
      var day = date.daysBetween(
        new Date().Format("yyyy-MM-dd"),
        this.g_searchParam.startDate
      );

      if (day < 0 || this.g_searchParam.startDate == "") {
        this.initDate();
      }
    },
    checkinDateChange(val) {
      //修改入住时间后离店时间也修改
      this.reWriteQueryDate(
        val,
        new Date(val).DateAdd("d", 1).Format("yyyy-MM-dd")
      );
    },
    checkoutDateChange(val) {
      //修改离店时间时只要修改离店时间，因为离店时间不可能小于入店时间
      this.reWriteQueryDate(this.g_searchParam.startDate, val);
    },

  // 检验是否登入，APP 小程序 跳转到该页面需要检索到自动登入 功能
    CheckLogin(){
     if (this.$route.query.cardNo!=undefined && this.$route.query.sign!=undefined) {
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.cardNo);
      params.append("sign", this.$route.query.sign);
 
      this.$http.post(api.CheckLoginState(), params.toParam()).then(data => {
        if(data.Result){ 
             // 自动登入成功--保存登录信息
             this.loginState=true;
            console.log("========测试========")
            console.log(this.loginState)
        
            var result = data.Data
            this.SaveUserInfo(result)
          }
        });
        }
    },

    SaveUserInfo(result) {
      // 保存登录信息
      console.log("-------------")
      var UserInfo = result
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
      // 保存登录信息
      this.setG_UserInfo(UserInfo)
    },


    reWriteQueryDate(checkinDate, checkoutDate) {
      var searchParam = this.g_searchParam;
      searchParam.startDate = checkinDate;
      searchParam.endDate = checkoutDate;
      this.setG_searchParam(searchParam);
    },
    // 全日房得到入住日期
    setRelaxDate(arriveDate) {
      var searchParam = this.g_searchParam;
      searchParam.arriveDate = arriveDate;
      this.setG_searchParam(searchParam);
    },
    // 全日房  开始时间 如：11
    setRelaxHour(relaxHour) {
      this.relaxHour = relaxHour;
      var searchParam = this.g_searchParam;
      searchParam.relaxHour = this.relaxHour;
      this.setG_searchParam(searchParam);
    },

    // bannerGoto(id) {
    //   window.location.href =
    //     "http://m.998.com/ActivityInfo/ActivityYekCMSDetail.html?dataId=" + id;
    // },

    ...mapMutations(["setG_searchParam", "setG_searchKeyWord","setG_UserInfo"])
  },
  filters: {
    formatCount(v) {
      if (v < 9999) {
        return v;
      } else {
        return (v / 10000).toFixed(0) + "万";
      }
    }
  },
  computed: {
    ...mapGetters([
      "g_city",
      "g_searchParam",
      "g_searchKeyWord",
      "g_currentCityName"
    ]),
    //计算今天和入住时间的差值
    day() {
      //今天
      var d1 = new Date();
      //入住时间
      var longDate = this.g_searchParam.startDate;
      var d2 = new Date(longDate);
      var s1 = d1.getTime(),
        s2 = d2.getTime();
      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
    },
    checkInDateFormat() {
      return new Date(this.g_searchParam.startDate).Format("M月D日");
    },
    checkOutDateFormat() {
      return new Date(this.g_searchParam.endDate).Format("M月D日");
    },
    arriveDateFormat() {
      return new Date(this.g_searchParam.arriveDate).Format("M月D日");
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date();
    },
    checkinMaxDate() {
      //最大入住日期为90天内
      return new Date().DateAdd("d", 89); //入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.startDate).DateAdd("d", 1);
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.startDate).DateAdd("d", 14);
    }
  }
};
</script>








<style lang="less">
@import "../../assets/theme.less";

.mu-date-picker .mu-text-field-input {
  color: transparent;
  z-index: 101;
}

.mu-text-field-content {
  padding: 0 0 0 0;
}

#Index_FirstPage {
  .mu-text-field-content {
    display: block;
    height: 100%;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    width: 5rem;
  }

  #FirstCity {
    .mu-text-field-content {
      width: 3rem;
      .mu-text-field-input {
        width: 3rem;
      }
    }
  }

  .mu-text-field {
    width: 2.4rem;
  }

  .mu-text-field-input {
    padding-top: 0.15rem;
  }

  .DateShow {
    position: absolute;
    color: #666666;
    top: 0;
    line-height: 55px;
    width: 2.3rem;
  }

  .BoxLeft {
    float: left;
    .mu-date-picker {
      width: 2.8rem;
      .mu-text-field {
        width: 2.8rem;
        .mu-text-field-content {
          width: 2.8rem;
          .mu-text-field-input {
            width: 2.8rem;
            margin-bottom: 0.2rem;
          }
        }
      }
    }
    .DateShow {
      margin-left: 56px;
    }
    .mu-text-field-content {
      padding-top: 0px;
    }
  }

  .BoxRight {
    float: left;
    .DateShow {
      margin-left: 0.35rem;
    }
    .mu-date-picker {
      width: 2.4rem;
    }
    .mu-date-picker {
      margin-left: 0.35rem;
      width: 2.1rem;
      .mu-text-field-content {
        width: 2.1rem;
        .mu-text-field-input {
          width: 2.1rem;
          margin-bottom: 0.2rem;
        }
      }
    }
    .mu-text-field-content {
      padding-top: 0px;
    }
  }
}

#Index_SecondPage {
  .mu-text-field-content {
    display: block;
    height: 100%;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    width: 5rem;
  }
  .mu-text-field-input {
    padding-top: 0.15rem;
  }

  #SecondCity {
    .mu-text-field-content {
      width: 3rem;
      .mu-text-field-hint {
        width: 3rem;
      }
      .mu-text-field-input {
        width: 3rem;
      }
    }
  }

  .formatDate {
    margin: auto 0;
    position: absolute;
    top: 0.3rem;
    // top: 1em;
    // bottom: 0;
    // width: 1.8rem;
    left: 56px;
    z-index: 100;
    color: #666666;
  }

  .mu-dropDown-menu-text {
    height: 0.8rem;
    line-height: 1.1rem;
  }
}

.flex-demo {
  position: relative;
  display: flex;
}

.Index_formatDate {
  // position: absolute;
  color: #666666;
}

.search {
  text-align: center;
  background-color: #f1f1f1;
  z-index: 2;
  position: relative;
  padding-bottom: 15px;
  .demo-paper {
    // #Datehomeindex {
    //   // .mu-text-field {
    //   //   // background-color:red
    //   //   width: 2.5rem;
    //   // }
    //   // .mu-text-field-hint {
    //   //   width: 2.5rem;
    //   // }
    // }
    #Timehomeindex {
      .mu-dropDown-menu-text {
        // background-color:red
        padding: 0;
      }
      .mu-text-field-hint {
        padding: 0;
      }
    }

    display: inline-block;
    height: auto;
    width: 95%;
    margin-top: -0.45rem;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    box-shadow: none;
    .search-panel {
      width: 100%;
      height: 100%;
      text-align: left;
      .tabDiv {
        width: 90%;
        margin-left: 5%;
        .mu-tab-text {
          font-size: 0.3rem;
        }
      }
      .mu-text-field-input {
        font-size: 0.3rem;
      }

      .mu-text-field-line {
        display: none;
      }
      .mu-text-field-focus-line {
        display: none;
      }
      .mu-text-field {
        margin-bottom: 0px;
      }
      // .mu-text-field-content {
      //   padding-top: 8px;
      //   padding-bottom: 8px;
      // }
      .dividerClass {
        width: 90%;
        margin-left: 5%;
      }
    }
    .selectKey {
      text-overflow: ellipsis;
    }
  }
}

.slider {
  max-width: 7.5rem;
  width: 100%;
  // background: url("../../../static/banner-item-load.png") no-repeat;
  // background-size: 100% 100% ;
  background-color: #eeeeee;
  img {
    max-width: 7.5rem;
    width: 100%;
    min-height: 2rem;
  }
}

.swiper-pagination {
  .swiper-pagination-bullet-active {
    background: @primaryColor;
  }
}

.swiper-pagination11 {
  .swiper-pagination-bullet-active {
    background: @primaryColor;
  }
}

.swiper-pagination22 {
  .swiper-pagination-bullet-active {
    background: @primaryColor;
  }
}

.flex-search {
  text-align: center;
  padding-bottom: 20px;
  padding-top: 20px;
}

.nearby {
  height: 1.4rem;
  justify-content: center;
  background-color: #fff;
  width: 95%;
  margin: 15px auto 15px auto;
  display: flex;
  border-bottom: 1px solid #eeeeee;
  a {
    margin: auto;
    color: #666666;
    font-size: 0.32rem;
    display: flex;
    img {
      margin-right: 0.2em;
      height: 0.5rem;
      width: 0.5rem;
    }
  }
}

.subMenu {
  background-color: #fff;

  // 下面这两行代码，华为荣耀4A 这个手机自带的浏览器打开有问题
  // justify-content: space-around;
  // display: flex;

  font-size: 0.28rem;
  padding: 0.4rem 0 0.5rem 0;

  overflow: hidden;
  .EntranceBox {
    float: left;
    width: 20%;
    img {
      width: 0.6rem;
      height: 0.6rem;
    }
    a {
      color: #666666;
    }
  }
}

.brands {
  h3 {
    margin-top: 0.2rem;
    height: 1rem;
    color: #333333;
    font-size: 0.34rem;
    margin: 0;
    line-height: 1rem;
    padding-left: 0.5em;
  }
}
.enters {
  width: 95%;
  margin-left: 4%;
  margin-left: auto;
  margin-right: auto;
  border-bottom: 1px solid #f1f1f1;
  margin-top: 10px;
  margin-bottom: 80px;
  .mu-item.show-left {
    padding-left: 52px;
    padding-right: 0px;
  }
}

.downloadApp {
  border-left: 1px solid #f1f1f1;
}

.colorCCC {
  color: #cccccc;
}
</style>




<style>
/* 何庆兰弄得JS */
</style>



// WEBPACK FOOTER //
// index.vue?59ff4108